import React, { useState, useContext, useEffect } from "react";
import "./Action.css";
import { useNavigate } from "react-router";
import { useSelector } from "react-redux";
import { Input, Button, Select } from "antd";
import Colors from "../../Helper/Colors";
import { toast } from "react-toastify";
import InputSeperator from "../Components/input_seperator";
import { techappContext } from "../../Api/techappReq";
import FormatHelper from "../../Helper/FormatHelper";
import Modal from "react-modal";
import PinInput from "react-pin-input";
import cameraIcon from "../../assets/images/camera.png";
import galleryIcon from "../../assets/images/gallery.png";
import Camera from "../Components/camera";
import SubmitDefineCost from "../Components/submit_define_cost";
import { GoAlertFill } from "react-icons/go";
import ExampleModal from "../Components/example_modal";
import Layout from "../../layout";
import { FaTimes } from "react-icons/fa";
import { IoIosArrowDown, IoIosArrowForward } from "react-icons/io";

const { Option } = Select;
const { TextArea } = Input;

const Complaint = () => {
  const navigate = useNavigate();
  const [submitModal, setSubmitModal] = useState(false);
  const selectedOrder = useSelector((state) => state.TechAppReducer.orderObj);
  const {
    servicesParts,
    servicesPartsData,
    submitUserCode,
    feeDeclarationHandler,
    defCostModal,
    setDefCostModal,
    callLogReq,
    feeDeclarationResendCode,
    resendCodeLoading,
    loading,
    fixComplaintHandler,
  } = useContext(techappContext);
  const [isRecieveFee, setIsRecieveFee] = useState(1);

  const [pickModal, setPickModal] = useState(false);
  const [isCamera, setIsCamera] = useState(false);

  const [showDoc, setShowDoc] = useState(false);
  const [doc, setDoc] = useState(null);
  const [submitCode, setSubmitCode] = useState("");
  const [inp, setInp] = useState(null);

  const [totalEarned, setTotalEarned] = useState(0);
  const [totalSpend, setTotalSpend] = useState(0);
  const [profit, setProfit] = useState("");
  const [spendTitle, setSpendTitle] = useState(null);
  const [spendAmount, setSpendAmount] = useState("");
  const [spendCount, setSpendCount] = useState("");
  const [spendItems, setSpendItems] = useState([]);
  const [sum, setSum] = useState(0);
  const [warrantyDesc, setWarrantyDesc] = useState("");
  const [description, setDescription] = useState("");
  const [isLabel, setIsLabel] = useState("");
  const [complaintDesc, setComplaintDesc] = useState("");

  const [imageList, setImageList] = useState([]);
  const [fileList, setFileList] = useState([]);
  const [isImageList, setIsImageList] = useState(false);
  const [exampleModal, setExampleModal] = useState(false);

  const settings = useSelector((state) => state.TechAppReducer.settings);
  const minTotalCost = settings?.minimum_total_cost_announcement ?? 350000;

  const upload = (e) => {
    let list = [];
    for (var i = 0; i < e.target.files.length; i++) {
      list.push(e.target.files[i]);
      fileList.push(e.target.files[i]);
    }
    list.forEach((li) => {
      imageList.push(URL.createObjectURL(li));
    });
    setIsImageList(true);
  };

  const removeFileHandler = (url, index) => {
    setImageList(imageList.filter((img) => img !== url));
    setFileList(
      fileList.filter((file, i) => {
        return i !== index;
      })
    );
  };

  const onPreview = async (file) => {
    setDoc(file);
    setShowDoc(true);
  };

  const addSpendItemsHandler = () => {
    let finalAmount = 0;
    if (
      spendTitle?.length === 0 ||
      spendAmount === 0 ||
      spendAmount.length === 0
    ) {
      toast.warning("لطفا ورودی های خرج کرد را بررسی کنید");
    } else {
      if (spendAmount.length === 0) {
        finalAmount = 0;
      } else {
        finalAmount = spendAmount;
      }
      let newObj = {
        title: spendTitle,
        amount: finalAmount,
        count: 1,
      };
      if (spendCount.length > 0) {
        newObj.count = spendCount;
      }
      spendItems.push(newObj);
      setSpendTitle(null);
      setSpendAmount("");
      setSpendCount("");
    }
  };

  const submitFormHandler = (e) => {
    e.preventDefault();
    calculateSum();
    let finalTotalSpend = 0;
    let newSum;
    let newSpendCount = 1;
    if (totalSpend.length === 0) {
      finalTotalSpend = 0;
    } else {
      finalTotalSpend = totalSpend;
    }
    if (spendCount.length > 0) {
      newSpendCount = spendCount;
    }
    if (spendAmount > 0) {
      newSum = sum + parseFloat(spendAmount * newSpendCount);
    } else {
      newSum = sum;
    }
    if (totalEarned < minTotalCost) {
      toast.warning(
        `حداقل مبلغ به انجام رسیدن سفارش ${FormatHelper.toPersianString(
          FormatHelper.numberSeperator(minTotalCost)
        )} تومان است در صورتی که کمتر از این مبلغ دریافت کرده اید سفارش انجام شده محسوب نمی‌شود بنابراین اقدام به کنسل کردن آن و درج هزینه در باکس کنسلی نمایید.`
      );
    } else if (profit < 1000) {
      toast.warning("مبلغ سود خالص نباید کمتر از ۱۰۰۰ تومان باشد");
    } else if (
      totalSpend > 0 &&
      spendItems.length === 0 &&
      spendTitle?.length === 0
    ) {
      toast.warning("لطفا جزییات خرج کرد را وارد کنید.");
    } else if (warrantyDesc.length === 0) {
      toast.warning("لطفا شرایط و جزئیات گارانتی را ثبت کنید");
    } else if (description.length === 0) {
      toast.warning("لطفا توضیحات را وارد کنید");
    } else if (isLabel.length === 0) {
      toast.warning("لطفا مشخص کنید که برچسب اشتراک زده اید یا نه");
    } else if (description.length < 6) {
      toast.warning("توضیحات نباید کمتر از ۶ حرف باشد");
    } else if (fileList.length === 0) {
      toast.warning("لطفا مستندات خود را اپلود کنید");
    } else if (
      spendTitle?.length > 0 &&
      spendAmount > 0 &&
      typeof spendAmount === "number"
    ) {
      if (newSum !== parseFloat(finalTotalSpend)) {
        toast.warning(
          "مجموع مبلغ های خرج کرد باید با کل مبلغ خرج کرد برابر باشد"
        );
      }
    } else if (newSum !== parseFloat(finalTotalSpend)) {
      toast.warning(
        "مجموع مبلغ های خرج کرد باید با کل مبلغ خرج کرد برابر باشد"
      );
    } else {
      if (spendTitle?.toString().length > 0 && spendAmount > 0) {
        setSubmitModal(true);
      } else {
        setSubmitModal(true);
      }
    }
  };

  const calculateSum = () => {
    let array = [];
    spendItems.forEach((x) => {
      if (parseFloat(x.amount) !== null && parseFloat(x.amount) > 0) {
        array.push(parseFloat(x.amount * x.count));
      }
    });
    if (array.length > 0) {
      setSum(array.reduce((accumulator, curr) => accumulator + curr, 0));
    }
    if (spendItems.length === 0) {
      setSum(0);
    }
  };

  useEffect(() => {
    servicesParts();
    if (
      selectedOrder?.net_profit2 &&
      parseFloat(selectedOrder?.net_profit2) > 0
    ) {
      setDefCostModal(true);
    }
  }, []);

  useEffect(() => {
    setIsImageList(false);
  }, [isImageList]);

  useEffect(() => {
    setProfit(totalEarned - totalSpend);
  }, [totalEarned, totalSpend]);

  useEffect(() => {
    calculateSum();
  }, [spendItems]);

  useEffect(() => {
    calculateSum();
  }, [spendAmount]);

  useEffect(() => {
    if (defCostModal === false) {
      setSubmitCode("");
    }
  }, [defCostModal]);

  return (
    <Layout>
      {selectedOrder ? (
        <>
          {selectedOrder.net_profit2 &&
          parseFloat(selectedOrder.net_profit2) > 0 ? (
            <>
              {/* header */}
              <div className="tech-app-header">
                <IoIosArrowForward
                  style={{ fontSize: "24px", paddingBottom: "5px" }}
                  onClick={() => navigate("/techapp")}
                />
                <span
                  onClick={() => navigate("/techapp/view-order")}
                  style={{ marginRight: "10px", cursor: "pointer" }}
                >
                  اعلام هزینه بابت {selectedOrder?.service?.data?.title} برای
                  مشتری {selectedOrder?.user?.data?.last_name}
                </span>
              </div>
              {/* open submit code modal button */}
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <Button
                  className="tech-app-operation-button btn-text-white"
                  style={{ backgroundColor: Colors.royalBlue }}
                  onClick={() => setDefCostModal(true)}
                >
                  تکمیل اعلام هزینه
                </Button>
              </div>
            </>
          ) : (
            <form className="techapp-define-cost">
              {/* header */}
              <div className="tech-app-header">
                <IoIosArrowForward
                  style={{ fontSize: "24px", paddingBottom: "5px" }}
                  onClick={() => navigate("/techapp")}
                />
                <span
                  onClick={() => navigate("/techapp/view-order")}
                  style={{ marginRight: "10px", cursor: "pointer" }}
                >
                  اعلام هزینه بابت {selectedOrder?.service?.data?.title} برای
                  مشتری {selectedOrder?.user?.data?.last_name}
                </span>
              </div>
              {/* complaint tabs */}
              <div
                style={{ marginTop: "10px" }}
                className="tech-app-action-define-cost-buttons"
              >
                <Button
                  onClick={() => setIsRecieveFee(1)}
                  disabled={loading}
                  style={
                    isRecieveFee === 1
                      ? { backgroundColor: Colors.warning }
                      : { backgroundColor: "white", color: Colors.secondary }
                  }
                >
                  هزینه گرفته ام
                </Button>
                <Button
                  disabled={loading}
                  onClick={() => setIsRecieveFee(0)}
                  style={
                    isRecieveFee === 0
                      ? { backgroundColor: Colors.warning }
                      : { backgroundColor: "white", color: Colors.secondary }
                  }
                >
                  هزینه نگرفته ام
                </Button>
              </div>
              {isRecieveFee === 1 ? (
                <>
                  {/* amounts section */}
                  <div
                    style={{ alignItems: "center" }}
                    className="tech-app-view-order-detail"
                  >
                    {/* total earned */}
                    <div className="techapp-define-cost-input-cost">
                      <div style={{ backgroundColor: Colors.royalBlue }}>
                        کل مبلغ دریافتی
                      </div>
                      <InputSeperator
                        disabled={loading}
                        value={totalEarned}
                        setValue={setTotalEarned}
                        className={"ant-input"}
                        placeHolder="تومان"
                        onBlur={() => {
                          if (parseFloat(totalEarned) < minTotalCost) {
                            toast.warning(
                              `حداقل مبلغ به انجام رسیدن سفارش ${FormatHelper.toPersianString(
                                FormatHelper.numberSeperator(minTotalCost)
                              )} تومان است در صورتی که کمتر از این مبلغ دریافت کرده اید سفارش انجام شده محسوب نمی‌شود بنابراین اقدام به کنسل کردن آن و درج هزینه در باکس کنسلی نمایید.`,
                              {
                                autoClose: 9000,
                                toastId: "define_cost_total_price_warning",
                              }
                            );
                          }
                        }}
                        style={{
                          width: "100%",
                          maxHeight: "100px",
                          textAlign: "center",
                          borderRadius: "6px 0 0 6px",
                        }}
                      />
                    </div>
                    {/* total spend */}
                    <div className="techapp-define-cost-input-cost">
                      <div style={{ backgroundColor: Colors.royalBlue }}>
                        کل مبلغ خرج کرد
                      </div>
                      <InputSeperator
                        disabled={loading}
                        value={totalSpend}
                        setValue={setTotalSpend}
                        className={"ant-input"}
                        placeHolder="تومان"
                        style={{
                          width: "100%",
                          maxHeight: "100px",
                          textAlign: "center",
                          borderRadius: "6px 0 0 6px",
                        }}
                      />
                    </div>
                    {/* net profit */}
                    <div style={{ textAlign: "center", width: "100%" }}>
                      مبلغ سود خالص{" "}
                      <span
                        style={
                          totalEarned - totalSpend < 0
                            ? { color: "red" }
                            : { color: Colors.success }
                        }
                      >
                        {profit &&
                          // FormatHelper.toPersianString(profit.toLocaleString())}
                          FormatHelper.toPersianString(
                            FormatHelper.numberSeperator(Math.abs(profit))
                          )}
                      </span>{" "}
                      تومان
                    </div>
                  </div>
                  {/* items section */}
                  <div
                    style={{ alignItems: "center" }}
                    className="tech-app-view-order-detail"
                  >
                    {/* add new item button */}
                    <Button
                      disabled={loading}
                      onClick={addSpendItemsHandler}
                      className="techapp-define-cost-add-new-row-btn"
                      style={{ backgroundColor: Colors.warning }}
                    >
                      افزودن سطر جدید
                    </Button>
                    {/* add new item box */}
                    <div className="techapp-define-cost-add-box">
                      {/* new item count */}
                      <div
                        style={{
                          backgroundColor: Colors.royalBlue,
                          position: "relative",
                        }}
                      >
                        <span className="techapp-new-row-span">
                          {FormatHelper.toPersianString(spendItems.length + 1)}
                        </span>
                      </div>
                      <div>
                        {/* new item title */}
                        <Select
                          disabled={loading}
                          showSearch
                          style={{ borderRadius: "6px 0 0 0", width: "100%" }}
                          className="techapp-select-border-radius"
                          optionFilterProp="children"
                          placeholder={"جزییات خرج کرد"}
                          defaultValue={spendTitle}
                          value={spendTitle}
                          onChange={(value) => setSpendTitle(value)}
                        >
                          {spendItems.find((o) => o.title === "96")
                            ? servicesPartsData
                                ?.filter((o) => o.id !== "96")
                                ?.map((item) => (
                                  <Option
                                    style={{ textAlign: "right" }}
                                    key={item.id}
                                    value={item.id}
                                  >
                                    {item.title}
                                  </Option>
                                ))
                            : servicesPartsData?.map((item) => (
                                <Option
                                  style={{ textAlign: "right" }}
                                  key={item.id}
                                  value={item.id}
                                >
                                  {item.title}
                                </Option>
                              ))}
                        </Select>
                        {/* new item amount */}
                        <InputSeperator
                          clearValue
                          disabled={loading}
                          value={spendAmount}
                          setValue={setSpendAmount}
                          className={"ant-input"}
                          placeHolder="مبلغ خرج کرد"
                          style={{
                            width: "100%",
                            maxHeight: "100px",
                            textAlign: "right",
                          }}
                        />
                        {/* item count */}
                        <Input
                          value={spendCount}
                          onChange={(e) => setSpendCount(e.target.value)}
                          type="number"
                          placeholder="تعداد"
                          min={1}
                          max={10}
                          style={{
                            width: "100%",
                            maxHeight: "100px",
                            textAlign: "right",
                            borderRadius: "6px 0 0 6px",
                          }}
                        />
                      </div>
                    </div>
                    {/* spend items */}
                    {servicesPartsData &&
                      spendItems &&
                      spendItems
                        .map((item, index) => (
                          <div
                            key={index}
                            className="techapp-define-cost-add-box"
                          >
                            {/* item count */}
                            <div
                              style={{
                                backgroundColor: Colors.royalBlue,
                                position: "relative",
                              }}
                            >
                              <span className="techapp-new-row-span">
                                {FormatHelper.toPersianString(index + 1)}
                              </span>
                            </div>
                            <div className="techapp-show-items-wrapper">
                              {/* item title */}
                              <div>
                                {servicesPartsData.map((x) => {
                                  return x.id === item.title && x.title;
                                })}
                              </div>
                              {/* item amount */}
                              <div>
                                {FormatHelper.toPersianString(
                                  FormatHelper.numberSeperator(item.amount)
                                )}{" "}
                                تومان
                              </div>
                              {/* item count */}
                              <div>
                                {FormatHelper.toPersianString(item.count)} عدد
                              </div>
                              {/* item delete button */}
                              <div
                                style={{
                                  backgroundColor: Colors.danger,
                                }}
                                className="techapp-define-cost-add-box-remove-btn"
                                onClick={() => {
                                  if (!loading) {
                                    setSpendItems(
                                      spendItems.filter((it, i) => i !== index)
                                    );
                                  }
                                }}
                              >
                                <div></div>
                              </div>
                            </div>
                          </div>
                        ))
                        .reverse()}
                  </div>
                  {/* warranty receipt section */}
                  <div className="view_order_warranty_digital_receipt">
                    <div style={{ display: "flex" }}>
                      <GoAlertFill
                        style={{ color: "#fcc603", minWidth: 30, fontSize: 18 }}
                      />
                      <div>
                        همکار گرامی با توجه به اهمیت بالای مدت زمان گارانتی و
                        عدم به وجود آمدن مشکلات با مشتری، شما باید اطلاعات کاملی
                        از مدت زمان گارانتی خدمات و قطعات ارائه شده را با مشتری
                        توافق و ثبت کنید. این گارانتی می تواند برای هر قطعه یا
                        هر خدمت از یک روز تا چند سال باشد، حتی می تواند شرایط
                        خاصی را هم تحت پوشش قرار دهد. دقت داشته باشید در صورت
                        شفاف نشدن مدت زمان گارانتی ( قطعه یا خدمت ) با توجه به
                        قانون حمایت از حقوق مشتری، شما تا 6 ماه موظف به گارانتی
                        هستید. در نظر داشته باشید تمام اطلاعاتی که شما در این
                        بخش تکمیل می‌کنید به همراه فرم گارانتی برای مشتری ارسال
                        خواهد شد . جهت مشاهده نمونه رسید گارانتی ارسالی به مشتری{" "}
                        <span
                          style={{
                            margin: "0 5px",
                            cursor: "pointer",
                            color: "red",
                          }}
                          onClick={() => setExampleModal(true)}
                        >
                          اینجا
                        </span>{" "}
                        کلیک کنید. <br /> مثال : <br />
                        <ul style={{ paddingRight: 12 }}>
                          <li>کمپرسور 2 ماه گارانتی دارد.</li>
                          <li>پمپ تخلیه یک هفته مهلت تست و گارانتی دارد.</li>
                          <li>لاستیک دور درب دستگاه یک سال گارانتی دارد .</li>
                          <li>
                            بک لایت دستگاه 1 هفته مهلت تست و گارانتی دارد.
                          </li>
                          <li>تعمیر برد دارای 3 ماه گارانتی است.</li>
                        </ul>
                      </div>
                    </div>
                    <TextArea
                      inputMode="text"
                      placeholder={
                        "لطفا شرایط و جزییات گارانتی خدمات و قطعات دستگاه مشتری را با دقت ثبت کنید"
                      }
                      value={warrantyDesc}
                      onChange={(e) => setWarrantyDesc(e.target.value)}
                      autoSize
                    />
                  </div>
                  {/* description */}
                  <TextArea
                    disabled={loading}
                    inputMode="text"
                    className="tech-app-view-order-detail"
                    placeholder={
                      "اگر توضیحات اضافه ای دارید در اینجا وارد کنید"
                    }
                    value={description}
                    autoSize
                    style={{ maxHeight: "120px", paddingTop: "10px" }}
                    onChange={(e) => setDescription(e.target.value)}
                  />
                  {/* user label buttons */}
                  <div
                    style={{ marginTop: "10px" }}
                    className="tech-app-action-define-cost-buttons"
                  >
                    <Button
                      disabled={loading}
                      onClick={() => setIsLabel(1)}
                      style={
                        isLabel === 1
                          ? { backgroundColor: Colors.warning }
                          : {
                              backgroundColor: "white",
                              color: Colors.secondary,
                            }
                      }
                    >
                      برچسب اشتراک زدم
                    </Button>
                    <Button
                      disabled={loading}
                      onClick={() => setIsLabel(0)}
                      style={
                        isLabel === 0
                          ? { backgroundColor: Colors.warning }
                          : {
                              backgroundColor: "white",
                              color: Colors.secondary,
                            }
                      }
                    >
                      برچسب اشتراک نزده ام
                    </Button>
                  </div>
                  {/* upload section */}
                  <div style={{ width: "90%", margin: "50px 0" }}>
                    <input
                      onChange={upload}
                      type="file"
                      name="filefield"
                      multiple="multiple"
                      style={{ display: "none" }}
                      ref={(fileInput) => setInp(fileInput)}
                    />
                    <div className="techapp-upload-wrapper">
                      <span
                        className="techapp-upload-file-btn"
                        onClick={() => {
                          if (!loading) {
                            setPickModal(true);
                          }
                        }}
                      >
                        ارسال مستندات
                      </span>
                      {/* show uploaded files list */}
                      <div
                        style={{
                          display: "flex",
                          width: "100%",
                          marginTop: "20px",
                          flexWrap: "wrap",
                        }}
                      >
                        {imageList.length > 0 &&
                          imageList.map((url, index) => (
                            <div style={{ position: "relative" }}>
                              <img
                                onClick={() => onPreview(url)}
                                src={url}
                                id="image-uploaded"
                                key={index}
                                className="techapp-define-cost-upload-image"
                                alt={'image'+index}
                              />
                              <span
                                onClick={() => {
                                  if (!loading) {
                                    removeFileHandler(url, index);
                                  }
                                }}
                                className="techapp-upload-remove-btn"
                              >
                                x
                              </span>
                            </div>
                          ))}
                      </div>
                    </div>
                  </div>
                  {/* submit button */}
                  <Button
                    className="tech-app-operation-button btn-text-white"
                    style={{
                      backgroundColor: Colors.royalBlue,
                      cursor: "pointer",
                    }}
                    onClick={submitFormHandler}
                    loading={loading}
                  >
                    ارسال اطلاعات
                  </Button>
                </>
              ) : (
                <>
                  <TextArea
                    placeholder="اگر توضیحات اضافه ای دارید وارد کنید"
                    style={{
                      width: "90%",
                      margin: "20px 0",
                      maxHeight: "120px",
                      paddingTop: "10px",
                    }}
                    autoSize
                    inputMode="text"
                    value={complaintDesc}
                    onChange={(e) => setComplaintDesc(e.target.value)}
                  />
                  {/* upload section */}
                  <div style={{ width: "90%" }}>
                    <input
                      onChange={upload}
                      type="file"
                      name="filefield"
                      multiple="multiple"
                      style={{ display: "none" }}
                      ref={(fileInput) => setInp(fileInput)}
                    />
                    <div className="techapp-upload-wrapper">
                      <span
                        className="techapp-upload-file-btn"
                        onClick={() => {
                          if (!loading) {
                            setPickModal(true);
                          }
                        }}
                      >
                        ارسال مستندات
                      </span>
                      {/* show uploaded files list */}
                      <div
                        style={{
                          display: "flex",
                          width: "100%",
                          marginTop: "20px",
                          flexWrap: "wrap",
                        }}
                      >
                        {imageList.length > 0 &&
                          imageList.map((url, index) => (
                            <div style={{ position: "relative" }}>
                              <img
                                onClick={() => onPreview(url)}
                                src={url}
                                id="image-uploaded"
                                key={index}
                                className="techapp-define-cost-upload-image"
                                alt={'image'+index}
                              />
                              <span
                                onClick={() => {
                                  if (!loading) {
                                    removeFileHandler(url, index);
                                  }
                                }}
                                className="techapp-upload-remove-btn"
                              >
                                x
                              </span>
                            </div>
                          ))}
                      </div>
                    </div>
                  </div>
                  <Button
                    className="tech-app-operation-button btn-text-white"
                    style={{
                      backgroundColor: Colors.royalBlue,
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      if (complaintDesc.length < 6) {
                        toast.warning("توضیحات باید حداقل ۶ حرف باشد");
                      } else {
                        fixComplaintHandler(complaintDesc, fileList);
                      }
                    }}
                    loading={loading}
                  >
                    ارسال اطلاعات
                  </Button>
                </>
              )}
            </form>
          )}
          {/* submit code modal */}
          {defCostModal && (
            <Modal
              ariaHideApp={false}
              isOpen={true}
              onRequestClose={() => setDefCostModal(false)}
              className="tech-app-def-cost-modal"
              style={{
                overlay: {
                  backgroundColor: "rgba(0, 0, 0, 0.551)",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  zIndex: "1000",
                },
              }}
            >
              <div className="tech-app-def-cost-modal-header">
                <div onClick={() => setDefCostModal(false)}>
                  <FaTimes />
                </div>
                <span>
                  کد تایید را از مشتری دریافت کنید , کد تایید دارای محدودیت
                  زمانی است
                </span>
              </div>
              <PinInput
                length={4}
                autoFocus
                type="numeric"
                inputMode="number"
                style={{
                  padding: "10px",
                  display: "flex",
                  justifyContent: "center",
                  margin: "10px 0 20px 0",
                }}
                inputStyle={{
                  border: "none",
                  backgroundColor: "rgba(255, 255, 255, 0.158)",
                  borderRadius: "6px",
                  margin: "0 5px",
                  width: "50px",
                  height: "55px",
                }}
                inputFocusStyle={{
                  border: "1px solid rgba(255, 255, 255, 0.158)",
                }}
                onChange={(value) => setSubmitCode(value)}
                autoSelect={true}
                regexCriteria={/^[ A-Za-z0-9_@./#&+-]*$/}
              />
              <div className="tech-app-def-cost-modal-footer">
                <Button
                  onClick={() =>
                    callLogReq(
                      selectedOrder?.address?.data?.mobile,
                      selectedOrder?.id
                    )
                  }
                  className="btn-text-white"
                  style={{
                    backgroundColor: Colors.royalBlue,
                    color: "white",
                    marginRight: "5px",
                  }}
                >
                  <a href={`tel:${selectedOrder?.address?.data?.mobile}`}>
                    تماس با مشتری
                  </a>
                </Button>
                <Button
                  loading={resendCodeLoading}
                  onClick={() => feeDeclarationResendCode(11)}
                  className="btn-text-white"
                  style={{
                    backgroundColor: Colors.royalBlue,
                    color: "white",
                    marginRight: "5px",
                  }}
                >
                  ارسال مجدد کد
                </Button>
                <Button
                  className="btn-text-black"
                  onClick={() => {
                    if (!submitCode || submitCode?.length !== 4) {
                      toast.warning("کد ارسال شده ۴ رقم میباشد");
                    } else {
                      submitUserCode(11, submitCode);
                    }
                  }}
                  style={{
                    backgroundColor: Colors.white,
                    color: "black",
                    marginLeft: "auto",
                  }}
                >
                  ثبت اطلاعات
                </Button>
              </div>
            </Modal>
          )}
          {/* show doc modal */}
          {showDoc && doc && (
            <Modal
              ariaHideApp={false}
              isOpen={true}
              onRequestClose={() => setShowDoc(false)}
              className="tech-app-view-order-showdoc-modal"
              style={{
                overlay: {
                  backgroundColor: "rgba(0, 0, 0)",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  zIndex: "100000",
                },
              }}
            >
              <FaTimes
                onClick={() => setShowDoc(false)}
                style={{
                  color: "white",
                  cursor: "pointer",
                  position: "absolute",
                  right: "30px",
                  top: "20px",
                  fontSize: "22px",
                }}
              />
              <img
                style={{ width: "100%", height: "100%" }}
                src={doc}
                alt="doc"
              />
            </Modal>
          )}
          {/* receipt example */}
          <ExampleModal open={exampleModal} setOpen={setExampleModal} />
          {/* pick modal */}
          <Modal
            ariaHideApp={false}
            isOpen={pickModal}
            onRequestClose={() => setPickModal(false)}
            className="tech-app-view-order-modal"
            style={{
              overlay: {
                backgroundColor: "rgba(0, 0, 0, 0.551)",
                display: "flex",
                justifyContent: "center",
                alignItems: "flex-end",
                zIndex: "10000",
              },
            }}
          >
            <p style={{ padding: "10px", marginBottom: "20px" }}>
              <IoIosArrowDown
                style={{ cursor: "pointer", padding: "0 10px" }}
                onClick={() => setPickModal(false)}
              />
              <span>انتخاب عکس</span>
            </p>
            <div
              onClick={() => {
                inp.click();
                setPickModal(false);
              }}
              style={{
                color: "black",
                display: "flex",
                alignItems: "center",
                padding: "15px 10px",
                marginBottom: "20px",
              }}
            >
              <img
                src={galleryIcon}
                alt="icon"
                style={{ width: "20px", marginLeft: "10px" }}
              />
              گالری
            </div>
            <div
              onClick={() => {
                if (window.outerWidth > 800) {
                  toast.warning(
                    "برای استفاده از دوربین باید از موبایل استفاده کنید"
                  );
                } else {
                  setIsCamera(true);
                  setPickModal(false);
                }
              }}
              style={{
                color: "black",
                display: "flex",
                alignItems: "center",
                padding: "15px 10px",
                marginBottom: "20px",
              }}
            >
              <img
                src={cameraIcon}
                alt="icon"
                style={{ width: "20px", marginLeft: "10px" }}
              />
              دوربین
            </div>
          </Modal>
          {/* camera modal */}
          <Modal
            ariaHideApp={false}
            isOpen={isCamera}
            onRequestClose={() => setPickModal(false)}
            className="tech-app-view-order-modal h-100"
            style={{
              overlay: {
                backgroundColor: "rgba(0, 0, 0, 0.551)",
                display: "flex",
                justifyContent: "center",
                alignItems: "flex-end",
                zIndex: "10000",
              },
            }}
          >
            <Camera
              modal={setIsCamera}
              fileList={fileList}
              imageList={imageList}
            />
          </Modal>
          {/* submit modal */}
          <SubmitDefineCost
            open={submitModal}
            setOpen={setSubmitModal}
            onOk={() => {
              if (
                spendTitle?.length === 0 ||
                spendTitle === null ||
                spendAmount === 0
              ) {
                feeDeclarationHandler(
                  11,
                  spendItems,
                  totalEarned,
                  profit,
                  description,
                  isLabel,
                  fileList,
                  warrantyDesc
                );
                setSubmitModal(false);
              } else {
                let newObj = {
                  title: spendTitle,
                  amount: spendAmount,
                  count: 1,
                };
                if (spendCount.length > 0) {
                  newObj.count = spendCount;
                }
                spendItems.push(newObj);
                setSpendTitle(null);
                setSpendAmount("");
                setSpendCount("");
                feeDeclarationHandler(
                  11,
                  spendItems,
                  totalEarned,
                  profit,
                  description,
                  isLabel,
                  fileList,
                  warrantyDesc
                );
                setSubmitModal(false);
              }
            }}
          />
        </>
      ) : null}
    </Layout>
  );
};
export default Complaint;
